import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Best-effort portrait lock for browsers that support the Screen
// Orientation API (mostly works in fullscreen / installed PWA contexts;
// silently rejected in regular tabs). The CSS overlay in globals.css is
// the fallback for everywhere else.
if (typeof window !== 'undefined' && window.screen?.orientation && 'lock' in window.screen.orientation) {
  // The lock() call is async and rejects when the page isn't fullscreen
  // — swallow the rejection so it doesn't surface as an unhandled error.
  ;(window.screen.orientation as ScreenOrientation & { lock?: (o: string) => Promise<void> })
    .lock?.('portrait')
    .catch(() => { /* not allowed outside fullscreen — overlay covers this */ })
}

const root = document.getElementById('app')
if (root) {
  createRoot(root).render(<App />)
}
